import type { ReactNode } from "react";
import { AppFooter } from "@/components/app-footer";
import { LanguageSwitcher } from "@/components/language-switcher";

/** Public surfaces: language switcher top-right, Qualify footer pinned below. */
export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <div className="container-page flex items-center justify-end gap-3 pt-4">
        <LanguageSwitcher compact />
      </div>
      <div className="flex flex-1 flex-col">{children}</div>
      <AppFooter />
    </div>
  );
}
